// Contact prefill only. This is not authentication and carries no credentials.
export const APPSTREAM_CUSTOMER = "appstream:customer-profile";
export const FP_READY = "facile-prenotare:ready";
export function appstreamCustomerFromEvent(event, parentWindow, allowedOrigins, businessId) {
  if (!businessId || event.source !== parentWindow || !allowedOrigins.includes(event.origin) || event.data?.type !== APPSTREAM_CUSTOMER || String(event.data.business_id) !== String(businessId)) return null;
  const value = event.data.customer;
  if (!value || typeof value.email !== "string" || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.email.trim()) || value.email.length > 254) return null;
  return {name:String(value.name||"").slice(0,150),email:value.email.trim(),phone:String(value.phone||"").slice(0,40)};
}
